import React, { useState } from "react";
import { useHistory } from 'react-router-dom';
import { Button, Modal } from "antd";
import "./bidmodal.scss";
// import winnerAva from "../../assets/images/HomePage/winner-ava.svg";
import { PATHS } from "@config/constants";
import { useTranslation } from "react-i18next";
import AvatarDefault from "@assets/images/ava.svg";
import Noti from "@assets/images/noti.svg";
import { getNotifyChangeBid, setNotifyChangeBid } from "@utils/cookie";

const ChangeBid = ({ results }) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(() =>
    JSON.parse(window.localStorage.getItem("notify-popup") || true)
  );

  if (getNotifyChangeBid() == null) {
    setNotifyChangeBid(true);
  }

  const handleOk = () => {
    setNotifyChangeBid(false);
    window.location.href = PATHS.RESULTS_DETAIL_PAGE.replace(
      ":cp_id",
      `${results[0]?.cp_id}#ceremony`
    );
  };

  const handleCancel = () => {
    setNotifyChangeBid(false);
    setIsModalVisible(false);
  };

  const hideNotifyChange = () => {
    setTimeout(() => {
      setNotifyChangeBid(false);
      setIsModalVisible(false);
    }, 5000);
  };
  hideNotifyChange();


  const handleRedirect = useHistory();
  const handleClick = () => {
        setNotifyChangeBid(false);
        setIsModalVisible(false);
        handleRedirect.push('/terms');
  };
  return (
    <>
      <Modal
        style={{ top: 190, width: 359 }}
        className="modal_bid_expire"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button id="btn_see_detail" className="btn_see_detail" key="submit" type="primary" onClick={handleClick}>
            {t("bid.see_detail")}
          </Button>,
        ]}>
        {/* <div className="ant-modal-body-image" /> */}
        <div className="ant-modal-body-user body_nofi_change">
          <div className="ant-modal-body-user-detail" style={{ display: "flex", width: "100%",alignItems: "center" }}>
            <img style={{width: "83px"}} src={Noti} />
            <h2 className="h2_noti_change">{ t("bid.bid_expiry") }</h2>
          </div>
        </div>
        <div className="ant-modal-body-prize">
          <p className="p_noti_change">{ t("bid.bid_expiry_content") }</p>
        </div>
      </Modal>
    </>
  );
};

export default ChangeBid;
